import React from 'react';
import {Image, Container, Row, Col, Button} from 'react-bootstrap';
import translate from '../../../../translate';
import CardImg from '../../../Landing2.0/assets/images/girl.png';
import CardsWbd from '../../../Landing2.0/assets/images/Tarjetas.png';
import './cardWirebit.css';

const CardWirebit = ({...props}) => {
  const {lan} = props;
  const transl = translate[lan].LandingCard.section4;

  return(
    <>
      <Container fluid className='card-wirebit-wrapper'>
        <Image src={CardImg} width={'100%'} height={'100%'} className='responsive-img-card-wirebit'/>
      </Container>
      <Container fluid className='cards-wirebit-wrapper'>
        <Row>
          <Col xl={6} lg={6} md={6} sm={12} className='background-beige-img-cards'>
            <Image src={CardsWbd} className='resize-cards-beige'/>
          </Col>
          <Col xl={6} lg={6} md={6} sm={12} className='col-padding-left'>
            <div className='background-beige'>
              <h1 className='title-card-wirebit'>{transl.title}</h1>
              <p className='text-card-wirebit'>{transl.subtitle}</p>
              <Button className='request-card-blue-btn' onClick={()=>window.open(window.location.origin + '/register','_blank')}>{transl.btn_request_card}</Button>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default CardWirebit;